class StretchModal extends HTMLElement {
  constructor() {
    super()
    this.modalOpenBtn = this.querySelector('[data-info-icon]')
    this.modalContainer = this.querySelector('[data-info-modal]')
    this.modalCloseBtn = this.querySelector('[data-info-close]')
    this.opened = false

    this.init()
  }

  init() {
    this.modalOpenBtn.addEventListener('click', (e) => {
      this.stretchModalOpen(e)
    })

    this.modalCloseBtn.addEventListener('click', (e) => {
      this.stretchModalClose(e)
    })

    this.modalOpenBtn.addEventListener('keyup', (e) => {
      if ((e.key == 'Enter' && this.opened == false) || (e.key == ' ' && this.opened == false)) {
        this.stretchModalOpen(e)
      }
    })

    document.addEventListener('keyup', (e) => {
      if (e.key == 'Escape' && this.opened == true) {
        this.stretchModalClose(e)
      }
    })
  }

  stretchModalOpen(e) {
    this.modalContainer.classList.add('stretch__modal-wrapper--open')
    let modal = this.querySelector('.stretch__modal')
    let modalTitle = modal.querySelector('.stretch__title')
    modal ? trapFocus(modal) : null
    modalTitle ? modalTitle.focus() : null
    this.opened = true
  }

  stretchModalClose(e) {
    this.modalContainer.classList.remove('stretch__modal-wrapper--open')
    this.opened = false
    removeTrapFocus()
  }
}

customElements.define('stretch-modal', StretchModal)
